import { IReceipt } from '@/types/receipt'

export const extractNgText = (receipt: IReceipt): string => {
  if (receipt.ngReason) {
    return receipt.ngReason
  }
  return receipt.otherNgReason
}
